module.exports = __webpack_public_path__ + "static/mission-img_1-16c6b60f913e9118c3b427b2713a1bb0.png";